import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-screen flex flex-column justify-content-center align-content-center align-items-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mt-4 text-xl font-semibold" }, " Welcome! ", -1)

import { config } from "@/config";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(config).LOGO,
      alt: "Quokka"
    }, null, 8, _hoisted_2),
    _hoisted_3
  ]))
}
}

})